var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp"},[_c('transition',{attrs:{"name":"press"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[(_vm.press)?_c('div',[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }